import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {NotificationModel} from '../views/models/notification.model';
import {BehaviorSubject} from 'rxjs';
import {environment} from '../../environments/environment';


@Injectable({providedIn: 'root'})
export class NotificationService {
  notification_change$ = new BehaviorSubject<NotificationModel[]>([]);
  oneSignalId: string;

  constructor(private httpClient: HttpClient) {
  }

  getNotifications() {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/notification_token').subscribe(
      (datas: NotificationModel[]) => {
        this.notification_change$.next(datas);
      }
    );
  }

  oneSignalLogin(bearerToken: string) {
    if (this.oneSignalId == undefined) {
      return;
    }
    console.log(this.oneSignalId);
    this.httpClient.post(environment.baseURL + '/v2/api' + '/onesignal_login/' + this.oneSignalId,
      {
        observe: 'body',
        responseType: 'json'
      }, {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + bearerToken
        })
      }).subscribe();
  }

  oneSignalLogout(bearerToken: string) {
    console.log(this.oneSignalId);
    if (this.oneSignalId == undefined) {
      return;
    }
    this.httpClient.post(environment.baseURL + '/v2/api' + '/notification_login_users/' + this.oneSignalId,
      {
        observe: 'body',
        responseType: 'json'
      }, {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + bearerToken
        })
      }).subscribe((data) => console.log(data));
  }

}
